import { processesRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';

export const useDisableProcess = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    processesRepo.disableProcess(id),
  );
